
import axios from "@/axios.js"

export default {
  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/interventions")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsByArtisan({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/interventionsByArtisan`)
        .then((response) => {
          commit('SET_ITEMS_ARTISAN', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsHasInvoice({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/interventions-has-invoice")
        .then((response) => {
          commit('SET_ITEMS_HAS_INVOICE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsDoesntHaveInvoice({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/interventions-doesnt-have-invoice")
        .then((response) => {
          commit('SET_ITEMS_DOESNT_HAVE_INVOICE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchImages(_, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/intervention/${id}/fetch_images`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  getItem(_, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/intervention/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/intervention", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(response.data.intervention, {id: response.data.intervention.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addImage(_, obj) {
    return new Promise((resolve, reject) => {
      axios.post("/add_intervention_image", obj)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/intervention/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM', response.data.intervention)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItemEtat({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/interventionEtat/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_ETAT', response.data.intervention)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  saveImage({ commit }, item) {
    console.log("actions save image:",item);
    return new Promise((resolve, reject) => {
      axios.put(`/saveImage`, item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/intervention/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeImage(_, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/interventionImage/${itemId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  sendAvisRequest({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/intervention/sendAvisRequest/${itemId}`)
        .then((response) => {
          commit('UPDATE_ITEM', response.data.intervention)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  setOld({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.post(`/intervention/setOld/${itemId}`)
        .then((response) => {
          commit('UPDATE_ITEM', response.data.intervention)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  sendPaiementUrl(_, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`/sendPaiementUrl`, obj)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  generatePaiementUrl(_, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`/generatePaiementUrl`, obj)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getInterventionBySecret(_, secret) {
    return new Promise((resolve, reject) => {
      axios.get(`/paiement/${secret}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  stripePost(_, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`/stripePost`, obj)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  fetchItemsNbrsInterventions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/usersNbrsInterventions`)
        .then((response) => {
          commit('SET_ITEMS_NBR_INTERVENTION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsHistoriquesByIntervetion({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.get(`/historiquesByIntervention/${itemId}`)
        .then((response) => {
          commit('SET_ITEMS_HISTORIQUES_BY_INTERVENTION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },




}
